import _ from "lodash";
import {
  displayPriceFormat,
  isQrCode,
  isStringNotNull,
  sendOrderClick,
  showMessageModalWithLoading,
} from "../../utils";
import {
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_DELIVERY,
  PAYMENT,
  STRIPE_MINIMUM_AMOUNT,
  EMPTY_CART_ERROR,
  ZERO_ORDER_ERROR,
  MINIMUM_ORDER_DELIVERY_ERROR,
  MINIMUM_ORDER_CLICK_AND_COLLECT_ERROR,
  MINIMUM_STRIPE_PAYMENT_ERROR,
  PAYMENT_NOT_AVAILABLE,
  PROMOTION_DELIVERY_FREE,
  MODIFY_ORDER_TYPE_PROMOTION,
} from "../../constants";
import { ERROR_NAMES, renderErrorMessage } from "../../utils/error";
import { showCartModal } from "../../redux/actions";
import store from "../../redux/store";

export const getMaximumPreparationTime = (commande) => {
  let maxPreparationTime = 0;
  _.map(commande, (product) => {
    const { preparationTime } = product;
    if (maxPreparationTime < parseInt(preparationTime, 10)) {
      maxPreparationTime = parseInt(preparationTime, 10);
    }
  });
  return maxPreparationTime;
};
export const getPaymentTypes = () => {
  const { paymentTypes } = store.getState().configurationReducer;
  const { qrcode, delivery } = store.getState().configurationReducer;
  const { shopConfiguration = {} } = store.getState().shopReducer;
  const { orderType, address: customerAddress } =
    store.getState().pendingOrderReducer;
  const { paymentTypes: deliveryPaymentTypes } = delivery;

  let shopPaymentTypes = [];
  let companyPaymentTypes = [];
  if (isQrCode() && qrcode) {
    shopPaymentTypes = qrcode.paymentTypes;
    companyPaymentTypes = qrcode.paymentTypes;
  } else if (customerAddress && orderType === ORDER_TYPE_DELIVERY) {
    companyPaymentTypes = deliveryPaymentTypes;
    shopPaymentTypes =
      shopConfiguration?.delivery?.paymentTypes ?? deliveryPaymentTypes;
  } else {
    companyPaymentTypes = paymentTypes;
    shopPaymentTypes = shopConfiguration.paymentTypes ?? paymentTypes;
  }

  return _.filter(companyPaymentTypes, (paymentType) =>
    shopPaymentTypes.includes(paymentType),
  );
};

export const checkOrder = async ({
  paymentType,
  card,
  commande,
  selectTime,
  setLoading,
  isPhoneIncorrect,
  setChoosePayment,
  phoneObj,
  setDateState,
  stripe,
}) => {
  if (!commande || _.isEmpty(commande)) {
    store.dispatch(showCartModal(false));
    showMessageModalWithLoading(setLoading, EMPTY_CART_ERROR);
    return;
  }

  const state = store.getState();
  const { user } = state.userReducer;
  const { numero } = user;
  const { minimum, minimumClickAndCollect, servicePrice } = state.shopReducer;
  const { orderTime } = state.orderReducer;
  const { orderType, totalPriceOrder, address, managementFee, freeDelivery } = state.pendingOrderReducer;
  const totalProductPriceWithoutFees =
    totalPriceOrder -
    ((freeDelivery ? 0 : (address?.deliveryPrice ?? 0)) + managementFee ?? 0);

  if (!servicePrice?.customAccountId) {
    showMessageModalWithLoading(setLoading, PAYMENT_NOT_AVAILABLE);
    return;
  }

  if (!isQrCode()) {
    const isInvalidOrderTime =
      !orderTime || (orderTime.value && !selectTime && orderTime.disabled);

    if (isInvalidOrderTime) {
      setDateState({ isValidDate: false });
      return;
    }
  }

  if ((isPhoneIncorrect || !isStringNotNull(numero)) && !isQrCode()) {
    setLoading(false);
    return;
  }

  if (
    orderType === ORDER_TYPE_DELIVERY &&
    totalProductPriceWithoutFees < minimum
  ) {
    showMessageModalWithLoading(
      setLoading,
      MINIMUM_ORDER_DELIVERY_ERROR(displayPriceFormat(minimum, false, true))
    );
    return;
  }

  if (
    orderType === ORDER_TYPE_CLICK_AND_COLLECT &&
    totalProductPriceWithoutFees < minimumClickAndCollect
  ) {
    showMessageModalWithLoading(
      setLoading,
      MINIMUM_ORDER_CLICK_AND_COLLECT_ERROR(
        displayPriceFormat(minimumClickAndCollect, false, true)
      )
    );
    return;
  }

  if (paymentType === PAYMENT.TYPE_STRIPE) {
    if (!card) {
      showMessageModalWithLoading(
        setLoading,
        renderErrorMessage("resource_missing")
      );
      return;
    }

    if (
      totalPriceOrder < STRIPE_MINIMUM_AMOUNT &&
      totalPriceOrder > 0
    ) {
      showMessageModalWithLoading(
        setLoading,
        MINIMUM_STRIPE_PAYMENT_ERROR(
          displayPriceFormat(STRIPE_MINIMUM_AMOUNT, false, true)
        )
      );
      return;
    }
  }

  setLoading(true);

  await sendOrderClick(
    {
      paymentType,
      card,
      stripe,
      setLoading,
      phoneObj,
      setChoosePayment,
      setDateState
    }
  );

  setChoosePayment(true);
};


export const getBillingFlags = ({ promotion, freeDelivery, orderType }) => {
  const isDeliveryFree =
    freeDelivery || promotion?.type === PROMOTION_DELIVERY_FREE;

  const isClickAndCollectPromo =
    promotion?.reconversionType ===
    MODIFY_ORDER_TYPE_PROMOTION.CLICK_AND_COLLECT;

  const isDeliveryOrder = orderType === ORDER_TYPE_DELIVERY;

  const shouldShowDeliveryFee = isDeliveryOrder || isClickAndCollectPromo;

  return {
    isDeliveryFree,
    isClickAndCollectPromo,
    shouldShowDeliveryFee,
  };
};
